import { render, staticRenderFns } from "./BannersPreview.vue?vue&type=template&id=b6389990&scoped=true"
import script from "./BannersPreview.vue?vue&type=script&lang=js"
export * from "./BannersPreview.vue?vue&type=script&lang=js"
import style0 from "./BannersPreview.vue?vue&type=style&index=0&id=b6389990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6389990",
  null
  
)

export default component.exports